import React from 'react';

const JS_D3_js = () => {
  return (
    <div >
      <h1>JS_D3_js</h1>
      <p>Placeholder component for: "JS D3.js"</p>
    </div>
  );
};

export default JS_D3_js;
